export interface BallInfo {
  boll: string;
  class: 'red' | 'blue' | 'green' | '0';
  title: string;
  sx: {
    id?: number;
    name: string;
    code?: string;
    wuxing: string;
  };
}

export interface DrawRecord {
  id?: number;
  game: string;
  period: number;
  numbers?: string;
  isopen: number;
  date?: string;
  format: BallInfo[];
  tm_num?: string;
  tm_dx?: string;
  tm_ds?: string;
  regular_count?: number;
  special_count?: number;
}

export type RecentDrawsResponse = Record<GameType, DrawRecord[]>;

export interface PlayType {
  id: number;
  title: string;
  tag: string;
  rule?: string;
  play_mode?: 'normal' | 'image' | 'image_text' | string;
  hit_effect_mode?: 'normal' | 'legacy' | string;
  background_image?: string;
  scene_width?: number;
  scene_height?: number;
  display_count?: number;
  predict_count?: number;
  prediction_rule?: 'hit' | 'exclude' | string;
  display_items?: Array<{
    enabled: boolean;
    name?: string;
    value: string;
    image?: string;
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    sort?: number;
  }>;
  hit_rate_text?: string;
  hit_rate_percent?: number | null;
}

export interface LegendGroup {
  label: string;
  values: string[];
}

export interface LotteryLegend {
  zodiac_numbers: LegendGroup[];
  wuxing_numbers: LegendGroup[];
  wave_numbers: LegendGroup[];
}

export interface ZiliaoRecord {
  id: number;
  type: string;
  period: number;
  title?: string; // 后端生成的预测内容HTML
  effect_values?: string[];
  visual_payload?: {
    mode: string;
    visual: string;
    hit_effect_mode?: 'normal' | 'legacy' | string;
    background_image?: string;
    scene_width?: number;
    scene_height?: number;
    items: Array<{
      name: string;
      value: string;
      display: string;
      hit: boolean;
      predicted?: boolean;
      image?: string;
      x?: number;
      y?: number;
      width?: number;
      height?: number;
    }>;
  } | null;
  tm_num?: string;
  tm_sx?: string;
  is_opened?: boolean;
  suc?: boolean | null; // true=准, false=错, null=未开奖
  open_title?: string;
  open_scope?: string;
}

export interface ZiliaoGroup {
  title: string;
  tag: string;
  play_mode?: 'normal' | 'image' | 'image_text' | string;
  rule?: string; // 玩法规则说明
  rule_details?: LegendGroup[];
  hit_rate_text?: string;
  hit_rate_percent?: number | null;
  records: ZiliaoRecord[];
}

export interface NextDraw {
  period: number;
  is_open: boolean;
  opentime: number;
}

export interface DrawTimeConfig {
  draw_time: string;
  hour: number;
  minute: number;
  second: number;
  timezone?: string;
  game: GameType;
}

export interface LotteryAdItem {
  id: number;
  title: string;
  position: string;
  image: string;
  link_url: string;
}

export interface LotteryAdResponse {
  enabled: boolean;
  fallback_enabled: boolean;
  fallback_tag: string;
  fallback_title: string;
  fallback_subtitle: string;
  list: LotteryAdItem[];
}

export interface LotterySiteSettings {
  site_name: string;
  site_short_name: string;
  site_url: string;
  site_logo: string;
  site_favicon: string;
  site_notice: string;
  site_description: string;
  service_contact: string;
  company_address: string;
  copyright_text: string;
  seo_keywords: string;
  seo_description: string;
}

export interface ApiResponse<T> {
  code: number;
  msg: string;
  data: T;
}

export interface LatestDrawResponse {
  prev: {
    format: BallInfo[];
    period: number;
    isopen: number;
    opentime?: number;
    regular_count?: number;
    special_count?: number;
  };
  next: NextDraw;
  is_drawing?: boolean;
}

export type GameType = 'amssc' | 'xamlhc' | 'amlhc' | 'xglhc';

export interface GameInfo {
  code: GameType;
  name: string;
  shortName: string;
}

export const GAMES: GameInfo[] = [
  { code: 'amssc', name: '澳门新新彩', shortName: '新新彩' },
  { code: 'xamlhc', name: '澳门下半场', shortName: '下半场' },
  { code: 'amlhc', name: '澳门六合彩', shortName: '澳六合' },
  { code: 'xglhc', name: '香港六合彩', shortName: '港六合' },
];
